import KeysCodesConst from '../constants/keysCodes';

// ############################ Imported from Old UI ###########################

// eslint-disable-next-line max-len
const continueOnEnterKey = (event: KeyboardEvent) =>
  event.code === KeysCodesConst.enter || event.code === KeysCodesConst.numpadEnter;

const addEventKeyUpListenerHelper = (elementId: string, functionToExe: () => void): (() => void) => {
  const input = window && window.document.getElementById(elementId);
  if (input !== null) {
    const onEventTrigger = (event: KeyboardEvent) => {
      if (continueOnEnterKey(event)) {
        event.preventDefault();
        // Trigger the button element with a click
        functionToExe();
      }
    };

    input.addEventListener('keyup', onEventTrigger);
    return () => {
      input.removeEventListener('keyup', onEventTrigger);
    };
  }
};

export default addEventKeyUpListenerHelper;
